import React from 'react';
import { Redirect, useHistory } from 'react-router-dom';

import { toast } from '@dashboard/context/ToastContext';

import useCheckoutEmbed from '@dashboard/hooks/useCheckoutEmbed';
import useUrlQuery from '@dashboard/hooks/useUrlQuery';

import { PAGE_TYPES } from '@dashboard/enums/page-types';

import CreateCheckoutFromTemplateDialog from '@dashboard/components/CreateCheckoutFromTemplateDialog';

const PageCreate = () => {
  const history = useHistory();
  useCheckoutEmbed();
  const { template: createFromTemplateId, page: pageId, title, type, from } = useUrlQuery();

  if (createFromTemplateId || pageId) {
    if (type === 'checkout') {
      return (
        <div className="fixed w-screen h-screen bg-white dark:bg-background">
          <CreateCheckoutFromTemplateDialog
            isOpen
            onClose={() => history.push(from || '/pages')}
            templateId={createFromTemplateId}
            pageId={pageId}
            productTitle={title}
            type="checkout"
            onCreate={checkout => {
              history.push(`/pages/${checkout._id}/customize`);

              toast({
                title: 'Checkout page created',
                description: 'Your checkout page has been created',
                status: 'success',
              });
            }}
            title="Name your checkout"
          />
        </div>
      );
    }

    if (type === PAGE_TYPES.EVENT) {
      return (
        <div className="fixed w-screen h-screen bg-white dark:bg-background">
          <CreateCheckoutFromTemplateDialog
            isOpen
            onClose={() => history.push(from || '/pages')}
            templateId={createFromTemplateId}
            pageId={pageId}
            pageTitle={title}
            type="form"
            onCreate={checkout => {
              history.push(`/pages/${checkout._id}/customize`);

              toast({
                title: 'Event created',
                description: 'Your event has been created',
                status: 'success',
              });
            }}
            title="Name your event"
          />
        </div>
      );
    }

    if (type === 'form') {
      return (
        <div className="fixed w-screen h-screen bg-white dark:bg-background">
          <CreateCheckoutFromTemplateDialog
            isOpen
            onClose={() => history.push(from || '/pages')}
            templateId={createFromTemplateId}
            pageId={pageId}
            pageTitle={title}
            type="form"
            onCreate={checkout => {
              history.push(`/pages/${checkout._id}/customize`);

              toast({
                title: 'Form created',
                description: 'Your form has been created',
                status: 'success',
              });
            }}
            title="Name your form"
          />
        </div>
      );
    }
  }

  return <Redirect to="/pages" />;
};

export default PageCreate;
